import type { DayType, Verdict } from "../../lib/api";

/** RP training days, as the plan names them. */
export const DAY_LABEL: Record<DayType, string> = {
  rest: "rest",
  light: "light",
  moderate: "moderate",
  hard: "hard",
};

/** How each kind of day reads, and the colour it gets in charts and lists. */
export const VERDICTS: Record<Verdict, { label: string; colour: string; className: string }> = {
  good: { label: "On track", colour: "#5e7a73", className: "pill-positive" },
  over: { label: "Over", colour: "#b4531a", className: "pill-warn" },
  under: { label: "Short", colour: "#c9a227", className: "pill-warn" },
  partial: { label: "Part logged", colour: "#d6d3d1", className: "pill-neutral" },
  none: { label: "Not logged", colour: "#ebe8e4", className: "pill-neutral" },
};

export function VerdictPill({ verdict }: { verdict: Verdict }) {
  const v = VERDICTS[verdict];
  return <span className={v.className}>{v.label}</span>;
}
